const navigationBar = {
  titles: {
    equipmentList: "Lista de Activos",
    assets: "Operaciones",
    area: "Áreas",
    worksModule: "CAO",
    stocks: "Inventario",
    calendar: "Calendario",
    support: "Soporte Técnico",
    userProfile: "Perfil de Usuario",
    CAO: "CAO"
  },
  area: "Área",
  CAO: "CAO",
  company: "Estructura de la Compañía",
  customer: "Cliente",
  dashboard: "Inicio",
  equipment: "Activo",
  equipmentType: "Tipo de Activo",
  hazardous: "Área peligrosa",
  inspectionList: "Inspecciones de Operaciones",
  logs: "Alertas",
  module: "Modulos",
  new: "Nuevo",
  plant: "Edificio",
  reliability: "Inspecciones de confiabilidad",
  repairList: "Registro de Reparaciones",
  sealTypes: "Tipo de Sello",
  signOut: "Cerrar Sesión",
  unit: "Unidad",
  user: "Usuario",
  userList: "Lista de Usuarios"
};
export default navigationBar;
